import jsonServerProvider from 'ra-data-json-server';

export default jsonServerProvider('https://idm.rbwtech.net');
